import React, { FC } from 'react';
import { InferProps } from '@violetta/ubeya/utils';
import { Modal as OriginalModal } from 'react-native';

export const Modal: FC<InferProps<OriginalModal>> = ({
  children,
  ...props
}) => <OriginalModal {...props}>{children}</OriginalModal>;
